module.exports = __webpack_public_path__ + "img/infoBg.9db5dc6d.png";